// Not unit tested

type DomObj = HTMLElement | Element;

export const offset = (el: DomObj) => {
	const rect = el.getBoundingClientRect();
	const win = el.ownerDocument.defaultView;

	return {
		top: rect.top + (win?.scrollY || win?.pageYOffset || 0),
		left: rect.left + (win?.scrollX || win?.pageXOffset || 0),
	};
};

/**
 * Finds the closest ancestor element (including the current node if it is an Element)
 * that matches the given CSS selector.
 * @deprecated Use el.closest(selector) directly instead.
 */
export function closest(element: Element, selector: string): Element | null;
/**
 * Finds the closest ancestor element (including the current node if it is an Element)
 * that matches the given CSS selector. For Element nodes, uses the native `closest` method.
 * For non-Element nodes (e.g., Text nodes), traverses up the parentNode chain and checks
 * each ancestor with `matches`.
 *
 * @param node - The starting node to search from. Can be an Element or any Node.
 * @param selector - The CSS selector to match against ancestor elements.
 * @returns The closest ancestor Element matching the selector, or `null` if none is found.
 *
 * @remarks
 * - For Element nodes, this is equivalent to `element.closest(selector)`.
 * - For non-Element nodes, this manually traverses up the DOM tree.
 * - Prefer using `el.closest(selector)` directly for Element nodes.
 */
export function closest(node: Node, selector: string): Element | null;
export function closest(node: Node, selector: string): Element | null {
	// Use native closest for Element nodes, otherwise traverse up manually
	if (node instanceof Element) {
		return node.closest(selector);
	}
	// For non-Element nodes (e.g., Text), traverse up parentNode chain
	let current: Node | null = node.parentNode;
	while (current) {
		if (current instanceof Element && current.matches(selector)) {
			return current;
		}
		current = current.parentNode;
	}
	return null;
}

export const isVisible = (el: HTMLElement): boolean => {
	// This matches jQuery's :visible selector
	// TODO: Maybe check the computed styles to make sure display is not "none" and visibility is not "hidden"
	return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
};

export const onDocumentReady = (fn: () => unknown): void => {
	if (document.readyState !== "loading") {
		// DOM is already ready
		setTimeout(fn, 0);
	} else {
		// Wait for DOMContentLoaded
		document.addEventListener("DOMContentLoaded", fn);
	}
};

/**
 * This serves as a replacement for jQuery's find method.
 * @param node
 * @param selector
 * @returns
 */
export function querySelectorAllIfAvailable(
	node: Node,
	selector: string,
): NodeListOf<Element> {
	if (
		"querySelectorAll" in node &&
		typeof node.querySelectorAll === "function"
	) {
		return (node as ParentNode).querySelectorAll(selector);
	} else {
		// Fallback to an empty NodeList for elements that don't have children
		return document.createDocumentFragment().querySelectorAll(selector);
	}
}
